// extracted by mini-css-extract-plugin
export default {"emptyResults":"MainContainer_emptyResults__a-XIC"};